<template>
  <div class="lesson_exit noprint">
    <div class="exit_btn">
      <a type="primary" icon="el-icon-close" size="large" @click="showMethod">{{ leaveButton }}</a>
    </div>

    <el-dialog :visible.sync="closeDialog" center custom-class="exit-dialog" :show-close="false">
      <span slot="title">{{ $t('leaveMyStageChatHistory.dialogTitle') }}</span>
      <p class="text-center description">
        <span v-html="dialogMessage"></span>
      </p>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeDialog = false" class="exit-buttons exit-button-no">
          {{ $t('leaveMyStageChatHistory.controls.cancel') }}
        </el-button>
        <el-button type="primary" @click="closeCurrentTab" class="exit-buttons exit-button-yes">
          {{ $t('leaveMyStageChatHistory.controls.confirm') }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      closeDialog: false,
      dialogMessage: null
    };
  },
  computed: {
    leaveButton() {
      return this.$t('leaveMyStageChatHistory.controls.leave');
    }
  },
  methods: {
    showMethod() {
      return this.showDialogMessage();
    },
    closeCurrentTab() {
      window.close();
    },
    showDialogMessage() {
      this.closeDialog = true;
    },
  },
};
</script>

<style scoped src="@/assets/css/pc/exit.css"></style>
